// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'

function getForm10InputValues() {
  return {
    stuwdruk: $("[data-name='form10_stuwdruk'] :input").val(),
    zone: $("[data-name='form10_zone'] label.selected > input[type='radio']").val(),
    borstwering_hgt: $("[data-name='form10_borstwering_hgt'] :input").val(),
    sparing_hgt: $("[data-name='form10_sparing_hgt'] :input").val(),
    bovenrek_hgt: $("[data-name='form10_bovenrek_hgt'] :input").val(),
    sparing_breedte: $("[data-name='form10_sparing_breedte'] :input").val(),
    grootste_vak_breedte: $("[data-name='form10_grootste_vak_breedte'] :input").val(),
    nagels: $("[data-name='form10_nails'] label.selected > input[type='radio']").val(),

    regel1_breedte: $("[data-name='form10_regel1_breedte'] :input").val(),
    regel1_dikte: $("[data-name='form10_regel1_dikte'] :input").val(),
    regel1_aantal_regels: $("[data-name='form10_regel1_aantal_regels'] :input").val(),
    regel1_kwaliteit: $("[data-name='form10_regel1_kwaliteit'] label.selected > input[type='radio']").val(),
    regel1_doorbuigeis: $("[data-name='form10_regel1_doorbuigeis'] label.selected > input[type='radio']").val(),
    regel1_stalen_hoeken: $("[data-name='form10_regel1_stalen_hoeken'] :input").val(),

    regel2_breedte: $("[data-name='form10_regel2_breedte'] :input").val(),
    regel2_dikte: $("[data-name='form10_regel2_dikte'] :input").val(),
    regel2_aantal_regels: $("[data-name='form10_regel2_aantal_regels'] :input").val(),
    regel2_kwaliteit: $("[data-name='form10_regel2_kwaliteit'] label.selected > input[type='radio']").val(),
    regel2_doorbuigeis: $("[data-name='form10_regel2_doorbuigeis'] label.selected > input[type='radio']").val(),
    regel2_stalen_hoeken: $("[data-name='form10_regel2_stalen_hoeken'] :input").val(),

    stijl_breedte: $("[data-name='form10_stijl_breedte'] :input").val(),
    stijl_dikte: $("[data-name='form10_stijl_dikte'] :input").val(),
    stijl_aantal_regels: $("[data-name='form10_stijl_aantal_regels'] :input").val(),
    stijl_kwaliteit: $("[data-name='form10_stijl_kwaliteit'] label.selected > input[type='radio']").val(),
    stijl_doorbuigeis: $("[data-name='form10_stijl_doorbuigeis'] label.selected > input[type='radio']").val(),
    stijl_hulpstukken_boven: $("[data-name='form10_stijl_hulpstijlen_boven'] label.selected > input[type='radio']").val(),
    stijl_aantal_hulpstukken_boven: $("[data-name='form10_stijl_aantal_hulpstijlen_boven'] :input").val(),
    stijl_hulpstukken_onder: $("[data-name='form10_stijl_hulpstijlen_onder'] label.selected > input[type='radio']").val(),
    stijl_aantal_hulpstukken_onder: $("[data-name='form10_stijl_aantal_hulpstijlen_onder'] :input").val(),
  };
}

function calculateForm10() {
  const data = getForm10InputValues();
  data.action = 'form10Calculate';

  $.post('/wp-admin/admin-ajax.php', data, function (html) {
    $('.calculation-result').html(html);
    $('#form10Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
  });
}

function calculateShortForm10() {
  const data = getForm10InputValues();
  data.action = 'form10ShortCalculate';

  $.post('/wp-admin/admin-ajax.php', data, function (html) {
    $('.calculation-result').html(html);
  });
}

$(document).ready(function () {

  $('#form10Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form10Calc .acf-form-submit').append('<input type="submit" id="calculate_short_form10" value="Verkorte berekening" class="calculate-btn btn grey"/>');
  $('#form10Calc .acf-form-submit').append('<input type="submit" id="calculate_form10" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form10').click(function (e) {
    e.preventDefault();
    calculateForm10();
  });

  $('#calculate_short_form10').on('click', function (e) {
    e.preventDefault();
    calculateShortForm10();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form10.js